import React, { useRef, useState, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
//import {ReactComponent as BtnPrev} from '../../Assets/icon_chevron_left.svg';
//import {ReactComponent as BtnNext} from '../../Assets/icon_chevron_right.svg';
//import threeDBtnImg from '../../Assets/3D.png';
import classes from './preview.module.css';

const PointOfView = {
    Front: 'front',
    Right: 'right',
    Back: 'back',
    Left: 'left',
}

const SelectedViewer = {
    ThreeSixty: 'ThreeSixtyViewer',
    ThreeD: 'ModelViewer',
    TwoD: 'Lifestyle',
  }

const Preview = (props) => {
    const [viewerBtnMapIndex, setViewerBtnMapIndex] = useState(0);
    const [buttons, setButtons] = useState([]);
    const [productSettings, setProductSettings] = useState(props.productSettings);
    const [buttonSize, setButtonSize] = useState({ width: 50, height: 50 }); // Default size
    const buttonsAdded = useRef(false);
    const userAgent = navigator.userAgent || window.opera;
    const isMobileDevice = /Mobi|Android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
    || (/android/i.test(userAgent));
    const verticalLayout = props.productSettings.orientation === "vertical" && !isMobileDevice;
    //Limit number of buttons to 3 when the width is too low
    const maxVisibleButtons = (verticalLayout && (props.parentHeight < 550)) || (props.parentWidth < 550) ? props.productSettings.minNumberOfButtons || 3: 4;
    const buttonsMargin = props.productSettings.buttonsMargin !== undefined ? props.productSettings.buttonsMargin : 10;
    const arrowColour = props.productSettings.arrowColour || "black";
    const [parentSize, setParentSize] = useState({
        width: props.parentWidth,
        height: props.parentHeight,
    });
    const [buttonsDivSize, setButtonsDivSize] = useState(props.buttonsDivSize);

    //TODO: Review. If we don't have viewpoint images, we won't get any buttons
    //But we only want to update once we've downloaded all files
    //This doesn't get called when props change

    //We take the 2 previous and next arrow buttons into account
    const updateButtonSize = () => {
        console.log('Update buttons size, parent width, height:', parentSize.width, parentSize.height);
        //We're now calculating the size of the buttons to be optimal versus the height or width
        //TODO: Use buttonsDivSize instead and keep buttons square
        // const totalMargin = (maxVisibleButtons + 1) * buttonsMargin; // Total margin space between buttons
        // console.log('Total margin:', totalMargin);
        // const availableSpace = verticalLayout
        //     ? parentSize.height - totalMargin
        //     : parentSize.width - totalMargin;

        // const size = availableSpace / (maxVisibleButtons + 2); // Adjusted button size

        setButtonSize({ width: buttonsDivSize, height: buttonsDivSize });
    };

    useEffect(() => {
        if (props.parentWidth !== parentSize.width || props.parentHeight !== parentSize.height) {
            setParentSize({ width: props.parentWidth, height: props.parentHeight });
        }
        setButtonsDivSize(props.buttonsDivSize);
    }, [props.parentWidth, props.parentHeight, props.buttonsDivSize]);

    // Update button size whenever parentSize changes
    useEffect(() => {
        if (parentSize.width < 0 || parentSize.height < 0) return;
        updateButtonSize();
    }, [parentSize, verticalLayout, buttonsDivSize]);

    useEffect(() => {
        //Following code is only called once as buttonsAdded.current becomes true after the first pass
        //We don't want to add buttons twice => need to clear current buttons after the first pass
        if (props.viewpointImages || props.productImages) {
            addButtons();
            buttonsAdded.current = true;
        }
    }, [props.viewpointImages, props.productImages, buttonSize]);

     /*
  Change order of buttons based on the 3 numbers below, where -1 means we don't show the corresponding buttons at all
  Product settings:
  {
  "ThreeSixtyViewer": 2,
  "Lifestyle": 3,
  "ModelViewer": 1,
  "orientation": "horizontal"
}
  */

const BtnPrev = ({ width, height, stroke, className }) => (
    <svg
      viewBox="0 0 512 512"
      width={width}
      height={height}
      className={className}
    >
      <g transform="matrix(-0.315249 0 0 0.315249 351.121 173.439)">
        <path d="m213.3 85.036 176.85 176.85-176.85 176.86" fill="none" stroke={stroke || "black"} strokeWidth="79.3px" />
      </g>
    </svg>
);

const BtnNext = ({ width, height, stroke, className }) => (
    <svg
      viewBox="0 0 512 512"
      width={width}
      height={height}
      className={className}
    >
      <g transform="matrix(0.315249 0 0 0.315249 160.879 173.439)">
        <path d="m213.3 85.036 176.85 176.85-176.85 176.86" fill="none" stroke={stroke || "black"} strokeWidth="79.3px" />
      </g>
    </svg>
);

    const addButtons = () => {
        console.log('Adding new buttons');
        const buttonsToAdd = [];

        let povOrder = Object.keys(PointOfView);

        if (props.is180Pan) {
            // If is180Pan, change order and exclude 'Back'
            povOrder = ['Left', 'Front', 'Right'];
        }

        //Create an array where the value is the order in which buttons should be rendered
        const settingsOrder = [
            {
                //Add the 3D button
                key: 'ModelViewer',
                value: productSettings.ModelViewer,
                addButton: () => {
                    console.log('Adding viewer buttons');
                    if (props.previewItems !== "") {
                        buttonsToAdd.push(
                            <img 
                                className={`PreviewImage ${verticalLayout? 'verticalButton' : ''}`}
                                key="3D" 
                                onClick={() => props.onSwitch3DViewer(SelectedViewer.ThreeD)} 
                                src={`${window.ASSET_BASE_URL || process.env.PUBLIC_URL}/ICON-ThreeDview.png`}
                                alt="3D model" 
                                width={buttonSize.width}
                                height={buttonSize.height} 
                            />
                        );
                    }
                }
            },
            {
                //Add 360 viewer point of view images
                key: 'ThreeSixtyViewer',
                value: productSettings.ThreeSixtyViewer,
                addButton: () => {
                    console.log('Adding 360 buttons');
                    povOrder.forEach(key => {
                        //props.is180Pan
                        const pointOfView = PointOfView[key];
                        const imageUrl = props.viewpointImages && props.viewpointImages[pointOfView] && props.viewpointImages[pointOfView][0];
                        
                        if (imageUrl) {
                            buttonsToAdd.push(
                                <img 
                                    className={`PreviewImage ${verticalLayout? 'verticalButton' : ''}`}
                                    key={pointOfView} 
                                    onClick={() => props.onChangeView(pointOfView)} 
                                    src={imageUrl} 
                                    alt={pointOfView} 
                                    width={buttonSize.width}
                                    height={buttonSize.height} 
                                />
                            );
                        }
                    });

                    //Add the top view image 
                    const topImage = props.productImages.find(imgObj => imgObj.image.includes('_top.jpg'));
                    if (topImage) {
                        buttonsToAdd.push(
                            <img
                                className={`PreviewImage ${verticalLayout? 'verticalButton' : ''}`}
                                key='topImage'
                                id={topImage.image}
                                onClick={() => props.OnChangePicture(topImage.image)}
                                src={topImage.thumbnail ? topImage.thumbnail : topImage.image}
                                alt='Product'
                                width={buttonSize.width}
                                height={buttonSize.height} 
                            />
                        );
                    }
                }
            },
            {
                //Go through productImages map and spawn buttons
                key: 'Lifestyle',
                value: productSettings.Lifestyle,
                addButton: () => {
                    console.log('Adding lifestyle buttons');
                    props.productImages.map((productImage, index) => {
                        if (productImage.image.includes('_top.jpg')) return; // Avoid adding top view again
                        buttonsToAdd.push(
                            <img
                                key={index}
                                id={productImage.image}
                                onClick={() => props.OnChangePicture(productImage.image)}
                                src={productImage.thumbnail ? productImage.thumbnail : productImage.image}
                                alt='Product'
                                width={buttonSize.width}
                                height={buttonSize.height} 
                            />
                        );
                    });
                }
            }
        ];

        // Filter out settings with a value of -1, and then sort by their values
        const validSettings = settingsOrder
            .filter(setting => setting.value > -1)
            .sort((a, b) => a.value - b.value);

        // Add buttons in the order of the sorted settings
        validSettings.forEach(setting => {
            setting.addButton();
        });

        setButtons(buttonsToAdd);
    }

    const handleNext = () => {
        //Cycle the index through the map
        setViewerBtnMapIndex((prevIndex) => (prevIndex + 1) % buttons.length);
    }

    const handlePrevious = () => {
        setViewerBtnMapIndex((prevIndex) => (prevIndex - 1 + buttons.length) % buttons.length);
    }

    const getVisibleButtons = () => {
        if (buttons.length <= maxVisibleButtons) {
            return buttons; // Show all buttons if they fit
        }

        const visibleButtons = [];
        for (let i = 0; i < maxVisibleButtons; i++) {
            const index = (viewerBtnMapIndex + i) % buttons.length;
            visibleButtons.push(buttons[index]);
        }
        return visibleButtons;
    };

    //Turn the arrow images to point up and down for vertical layout
    return (
        /*previewCarousel.verticalPreview needs to have its width set depending on the window size + 
        all viewer components need to get their size reduced accordingly */
        <div className={`previewCarousel ${verticalLayout ? 'verticalPreview' : ''}`}>
        
            <button 
            className={`buttonViewer ${verticalLayout ? 'verticalButton' : ''}`} 
            onClick={handlePrevious}> 
            {/* disabled={viewerBtnMapIndex === 0}> */}
                <BtnPrev  
                    alt="Prev"
                    width={buttonSize.width}
                    height={buttonSize.height} 
                    className={verticalLayout? "rotateUp" : ""}
                    stroke= {arrowColour}
                />

            </button>
            {getVisibleButtons().map((button, index) => (
                <div key={index} className={`previewItem ${verticalLayout? 'verticalButton' : ''}`}>
                    {button}
                </div>
            ))}
            <button 
                className={`buttonViewer ${verticalLayout? 'verticalButton' : ''}`} 
                onClick={handleNext} >
            {/* disabled={viewerBtnMapIndex >= buttons.length - 4}> */}
                <BtnNext
                    alt="Next"
                    width={buttonSize.width}
                    height={buttonSize.height} 
                    className={verticalLayout? "rotateDown" : ""}
                    stroke= {arrowColour}
                />
            </button>
        </div>
    )
}

export default Preview;